export default __webpack_public_path__ + "static/media/rateTraining.f0afbb29.png";